import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router';
import { Link } from 'react-router-dom';
import { Translate } from "../../helpers/Translate";
import axios from 'axios';
const t = new Translate();

const nameMapped: any = {
    dashboard: "Dashboard",
    home: "Home",
    ewallet: "Smart E-Wallet",
    groupmeetings: "Group Meetings",
    viewstudents: "Students",
    schoolfees: "School Installments",
    servicesubscription: "Service subscriptions",
    finance: "Smart Wallet",
    latearrival: "Late Arrival",
    earlydismissal: "Early Dismissal",
    excuses: "Excuses",
    meetings: "Meetings",
    academicinterventions: "Academic Interventions",
    interventions: "Character Interventions",
    clinicvisits: "Clinic Visits",
    WallOfLove: "Wall Of Love",
    cafeteria: "Cafeteria",
    resturant: "Resturant",
    transaction: "Transaction",
    payments: "Payments",
    subscriptions: "Subscriptions",
    installments: "Installments",
    parentmenu: "Parent Menu",
    profilemenu: "Profile Menu",
    changepassword: "Change Password",
    editprofile: "Edit Profile",
    viewprofile: "View Profile",
    parentcard: "Parent Card",
    chatcontent: "Chat Content",
    chatlist: "Chat List",
    chatbody: "Chat Body",
    dopayment: "Do Payment",
    classactivities: "Class Activities",
    cafeteriamenu: "Cafeteria Menu",
    "Reinforcement-point": "Reinforcement Point",
    "progress-report": "Progress Report",
    "map-growth": "Map Growth",
}

// URL segment -> Font Awesome icon (same icons as the side nav).
// Segments without an entry (e.g. ids) are shown without an icon.
const iconMapped: any = {
    dashboard: "fas fa-th-large",
    home: "fas fa-home",
    ewallet: "fas fa-wallet",
    groupmeetings: "fas fa-users",
    viewstudents: "fas fa-user-graduate",
    schoolfees: "fas fa-file-invoice-dollar",
    servicesubscription: "fas fa-concierge-bell",
    finance: "fas fa-wallet",
    latearrival: "far fa-clock",
    earlydismissal: "fas fa-door-open",
    excuses: "fas fa-bed",
    meetings: "fas fa-comments",
    academicinterventions: "fas fa-book",
    interventions: "fas fa-ban",
    clinicvisits: "fas fa-stethoscope",
    WallOfLove: "fas fa-heart",
    walloflove: "fas fa-heart",
    cafeteria: "fas fa-apple-alt",
    resturant: "fas fa-utensils",
    transaction: "fas fa-exchange-alt",
    payments: "fas fa-credit-card",
    subscriptions: "fas fa-receipt",
    installments: "fas fa-calendar-alt",
    parentmenu: "fas fa-bars",
    profilemenu: "fas fa-user-cog",
    changepassword: "fas fa-key",
    editprofile: "fas fa-user-edit",
    viewprofile: "fas fa-user",
    parentcard: "fas fa-id-card",
    chatcontent: "fas fa-comment-dots",
    chatlist: "fas fa-comments",
    chatbody: "fas fa-comment",
    dopayment: "fas fa-money-check-alt",
    classactivities: "fas fa-chalkboard-teacher",
    cafeteriamenu: "fas fa-utensils",
    cafeteriaMenu: "fas fa-utensils",
    "Reinforcement-point": "fas fa-star",
    "progress-report": "fas fa-chart-line",
    "map-growth": "fas fa-seedling",
}

const Breadcrumbs = () => {
    const location = useLocation();
    const path = location?.pathname;
    const pathnames = path?.split('/')?.filter(x => x);
    const currentPage = pathnames?.length ? (pathnames[pathnames?.length - 1] ?? "") : "";
    const [currentPageName, setCurrentPageName] = useState(currentPage);
    useEffect(() => {
        const segments = path?.split('/')?.filter(x => x);
        if (!segments || (!segments?.length)) {
            return;
        }
        const page = segments[segments.length - 1] ?? "";
        if (nameMapped?.hasOwnProperty(page)) {
            setCurrentPageName(nameMapped[page]);
        } else {
            const parent = segments[segments.length - 2];
            if (!parent) {
                return;
            }
            axios.get((process.env.REACT_APP_BASEURL) + `get_breadcrumbs.php?path=${path}&curr=${page}`)?.then((response: any) => {
                const res_data_data = response?.data?.data
                if (!res_data_data) {
                    return;
                }
                setCurrentPageName(res_data_data);
                nameMapped[page] = res_data_data;
            })
        }

    }, [path]);
    if (!pathnames || (!pathnames?.length)) {
        return null;
    }

    return (
        <div className="pp-page-header">
            <h1 className="mt-4">
                {currentPage && iconMapped[currentPage] && (
                    <i className={`pp-page-title-icon ${iconMapped[currentPage]}`} aria-hidden="true"></i>
                )}
                {t.translate(currentPageName)}
            </h1>
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                    {pathnames.map((value, index) => {
                        const to = `/${pathnames.slice(0, index + 1).join('/')}`;
                        const isLast = index === pathnames.length - 1;
                        return (
                            <li
                                key={to}
                                className={`breadcrumb-item ${isLast ? "active" : ""}`}
                                aria-current={isLast ? "page" : undefined}
                            >
                                <Link to={to}>
                                    {iconMapped[value] && (
                                        <i className={iconMapped[value]} aria-hidden="true"></i>
                                    )}
                                    {t.translate(nameMapped?.hasOwnProperty(value) ? nameMapped[value] : value)}
                                </Link>
                            </li>
                        );
                    })}
                </ol>
            </nav>
        </div>
    );

}

export default Breadcrumbs
